// eslint-disable-next-line strict
module.exports = null;
